    <div class="w-full h-full p-5">
        <!-- Export icon row -->
        <div class="flex justify-end mb-2 gap-2 w-full">
            <span 
                class="material-icons text-black text-opacity-50 cursor-pointer text-2xl"
                matTooltip="Refresh"
                matTooltipClass="custom-orange-tooltip"
                matTooltipPosition="left"
                (click)="refresh()">
                refresh
            </span>
            <span 
                class="material-icons text-black cursor-pointer text-2xl"
                matTooltip="Export to Excel"
                matTooltipClass="custom-orange-tooltip"
                matTooltipPosition="left"
                (click)="print()">
                print
            </span>
        </div>
        <form [formGroup]="form">

            <!-- Row 1: First Name, Middle Name, Last Name -->
            <div class="grid grid-cols-12 gap-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-100-px font-semibold">First Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="firstName"
                            type="text"
                            placeholder="First Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-120-px font-semibold">Middle Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="middleName"
                            type="text"
                            placeholder="Middle Name">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-100-px font-semibold">Last Name:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            style="text-transform: capitalize;"
                            formControlName="lastName"
                            type="text"
                            placeholder="Last Name">
                    </div>
                </div>
            </div>

            <!-- Row 2: Phone Number, Status, Account Type -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-120-px font-semibold">Phone Number:</span>
                        <input
                            class="placeholder-black focus:outline-none w-full h-30-px bg-gray-100 rounded-md pl-3 italic"
                            formControlName="phoneNumber"
                            type="text"
                            placeholder="Phone Number">
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-80-px font-semibold">Status:</span>
                        <app-dropdown-field
                            [options]="statusOptions"
                            [selectedText]="statusType_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setStatusType($event.label, $event.value)">
                        </app-dropdown-field>
                    </div>
                </div>
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-110-px font-semibold">Account Type:</span>
                        <app-dropdown-field
                            [options]="accountTypeOptions"
                            [selectedText]="accountType_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setAccountType($event.label, $event.value)">
                        </app-dropdown-field>
                    </div>
                </div>
            </div>

            <!-- Row 3: Tier (left-aligned, col-span-4) -->
            <div class="grid grid-cols-12 gap-3 mt-3">
                <div class="col-span-4">
                    <div class="card-input flex items-center text-xs py-2 w-full">
                        <span class="text-xs w-60-px font-semibold">Tier:</span>
                        <app-dropdown-field
                            [options]="tierOptions"
                            [selectedText]="tier_text"
                            placeholder="== Select an option =="
                            (selectionChange)="setTier($event.label, $event.value)">
                        </app-dropdown-field>
                    </div>
                </div>
            </div>

        </form>

        <!-- Submit Button -->
        <div class="w-full flex items-center justify-center mt-10 mb-4">
            <button
                (click)="submit()"
                class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2">
                submit
            </button>
        </div>
        <!-- Data Table Section -->
        <div *ngIf="showTable">
            <div *ngIf="submitted">
                <div class="flex flex-col gap-2 bg-light-orange p-2">
                    <app-table-controls
                        [customClass]="'-mt-2'"
                        [currentLimit]="size"
                        [searchPlaceholder]="'Search'"
                        (limitChangeEvent)="onLimitChangeFromComponent($event)"
                        (searchKeyupEvent)="onSearchKeyupFromComponent($event)"
                        (keydownEvent)="keyDownFunction($event)">
                    </app-table-controls>
                
                    <div class="bg-light-orange" style="border-left: 1px solid #CAC2BC; border-right: 1px solid #CAC2BC;">
                        <app-data-table
                            [tableSubHeader]="tableSubHeader"
                            [isLoading]="isLoading"
                            [sort_type]="sort_type"
                            (toggleOnSort)="sortList($event.key, $event.type)">
                            <tr class="focus:outline-none" *ngFor="let item of itemLists">
                                <td>{{ item.firstName | nullWithDefault | titlecase }}</td>
                                <td>{{ item.middleName | nullWithDefault | titlecase }}</td>
                                <td>{{ item.lastName | nullWithDefault | titlecase }}</td>
                                <td>{{ item.phoneNumber | nullWithDefault }}</td>
                                <td>{{ item.email | nullWithDefault }}</td>
                                <td>{{ item.dateCreated | nullWithDefault | date:'yyyy-MM-dd' }}</td>
                                <td>{{ item.status | nullWithDefault }}</td>
                                <td>{{ item.accountType | nullWithDefault }}</td>
                                <td>{{ item.tier | nullWithDefault }}</td>
            
                                <!-- Referral Count — clickable -->
                                <td class="text-center">
                                    <span
                                        class="referral-count-link cursor-pointer font-semibold blue-text underline"
                                        (click)="openViewReferral(item)">
                                        {{ item.referralCount | nullWithDefault }}
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="!isLoading && itemLists.length === 0">
                                <td [attr.colspan]="tableSubHeader?.length || 12" class="text-center py-4 h-250-px text-gray-500 italic">
                                    No referral records found.
                                </td>
                            </tr>
                        </app-data-table>
                    </div>
                    <app-pagination
                        [currentPage]="current_page"
                        [totalPages]="total_pages"
                        [pageSize]="size"
                        [totalItems]="total"
                        (pageChange)="setPage($event)"
                        (previousPage)="prevPage()"
                        (nextPage)="nextPage()"
                        showTotalEntries="true">
                    </app-pagination>
                </div>
            </div>
        </div>
    </div>


<ngx-spinner type="border" size="medium">
    <app-megapay-loader></app-megapay-loader>
</ngx-spinner>